// removed by extract-text-webpack-plugin
module.exports = {"content":"ConsentTypeRedDeerCalgary__content__2wKl6","parentContainer":"ConsentTypeRedDeerCalgary__parentContainer__1g7y4"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ConsentTypeRedDeerCalgary/ConsentTypeRedDeerCalgary.css
// module id = 1401
// module chunks = 0